import { SERVICE_STATUS_COLOURS, SERVICE_STATUS_LABELS } from '../../types/velociraptor-settings'

const COLOUR_CLASSES: Record<string, string> = {
  green: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300',
  red: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300',
  yellow: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300',
  gray: 'bg-stone-100 text-stone-800 dark:bg-stone-700 dark:text-stone-300',
}

const DOT_CLASSES: Record<string, string> = {
  green: 'bg-green-500',
  red: 'bg-red-500',
  yellow: 'bg-yellow-500',
  gray: 'bg-stone-400',
}

interface StatusBadgeProps {
  status: string
  label?: string
}

export function StatusBadge({ status, label }: StatusBadgeProps): React.ReactElement {
  const colour = (SERVICE_STATUS_COLOURS as Record<string, string | undefined>)[status] ?? 'gray'
  const fallbackLabel =
    (SERVICE_STATUS_LABELS as Record<string, string | undefined>)[status] ?? status
  const displayLabel = label ?? fallbackLabel
  const badgeColour = COLOUR_CLASSES[colour] ?? COLOUR_CLASSES['gray'] ?? ''
  const dotColour = DOT_CLASSES[colour] ?? DOT_CLASSES['gray'] ?? ''

  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${badgeColour}`}
    >
      <span className={`mr-1.5 h-1.5 w-1.5 rounded-full ${dotColour}`} />
      {displayLabel}
    </span>
  )
}
